var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsgRecSomethingMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H12V16H4V18ZM4 14H12V12H4V14ZM2 22C1.45 22 0.979167 21.8042 0.5875 21.4125C0.195833 21.0208 0 20.55 0 20V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H10L16 8V20C16 20.55 15.8042 21.0208 15.4125 21.4125C15.0208 21.8042 14.55 22 14 22H2ZM9 9V4H2V20H14V9H9Z",
    fill: "#388010"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 5.5,
    r: 5.5,
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5C12.3625 7.5 12.2448 7.45104 12.1469 7.35313C12.049 7.25521 12 7.1375 12 7C12 6.8625 12.049 6.74479 12.1469 6.64688C12.2448 6.54896 12.3625 6.5 12.5 6.5C12.6375 6.5 12.7552 6.54896 12.8531 6.64688C12.951 6.74479 13 6.8625 13 7C13 7.1375 12.951 7.25521 12.8531 7.35313C12.7552 7.45104 12.6375 7.5 12.5 7.5ZM12 6V3H13V6H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgRecSomethingMissing);
export default __webpack_public_path__ + "static/media/EsgRecSomethingMissing.0e06808fbbd4840ecd1795507bb6dbf0.svg";
export { ForwardRef as ReactComponent };